import { useQuery } from '@apollo/client';
import { GET_PRODUCT_REVIEW_REPORTTYPE } from '..';

export function useQueryGetProductReportType() {
  const { data } = useQuery(GET_PRODUCT_REVIEW_REPORTTYPE);

  return { reportTypeList: data ? data.productReview.reportTypes : undefined };
}
